module.exports = __webpack_public_path__ + "static/media/platform-step2-desktop.39df3531.png";